const Auxillary = {
    getRandomInt: (max) => {
        return Math.floor(Math.random() * max);
    }
}

export default Auxillary;